import { render, staticRenderFns } from "./gala.vue?vue&type=template&id=3655044c&scoped=true"
import script from "./gala.vue?vue&type=script&lang=js"
export * from "./gala.vue?vue&type=script&lang=js"
import style0 from "./gala.vue?vue&type=style&index=0&id=3655044c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3655044c",
  null
  
)

export default component.exports